.root {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: var(--rt-width, 48px);
  height: var(--rt-height, 24px);
  vertical-align: middle;
  margin: 0 4px;
}

.input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.input:disabled {
  cursor: default;
}

.track {
  position: absolute;
  inset: 0;
  box-sizing: border-box;
  background-color: var(--rt-border-color, var(--rt-border-color-off, #aaa));
  border-radius: var(--rt-radius, 256px);
  transition: background-color 0.3s ease-out;
  pointer-events: none;
}

.track::before {
  content: "";
  position: absolute;
  inset: var(--rt-border-width, 2px);
  border-radius: var(--rt-radius-bg, 256px);
  background-color: var(--rt-background-color, var(--rt-background-color-off, #fff));
  transition: background-color 0.3s ease-out;
}

.knob {
  position: absolute;
  top: 50%;
  left: var(--rt-knob-gap, 4px);
  width: var(--rt-knob-width, 16px);
  height: var(--rt-knob-height, 16px);
  border-radius: var(--rt-knob-radius, 100%);
  background-color: var(--rt-knob-color, var(--rt-knob-color-off, #aaa));
  transform: translateY(-50%);
  transition:
    left 0.2s ease-out,
    background-color 0.3s ease-out;
}

.input:checked ~ .track {
  background-color: var(--rt-border-color, var(--rt-border-color-on, #3887b7));
}

.input:checked ~ .track::before {
  background-color: var(--rt-background-color, var(--rt-background-color-on, #fff));
}

.input:checked ~ .track .knob {
  left: calc(100% - var(--rt-knob-width, 16px) - var(--rt-knob-gap, 4px));
  background-color: var(--rt-knob-color, var(--rt-knob-color-on, #3887b7));
}

.input:disabled ~ .track {
  background-color: var(--rt-background-color-disabled, #eee);
}

.input:disabled ~ .track .knob {
  background-color: var(--rt-background-color-disabled, #eee);
}

.input:focus-visible ~ .track {
  outline: 2px solid Highlight;
  outline: 2px solid -webkit-focus-ring-color;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .track,
  .track::before,
  .knob {
    transition: none;
  }
}
